import React from 'react';
import styled, { useTheme } from 'styled-components';
import { Camera } from '@williamhill/rosi-ui-shared/src/assets/icons/peripherals/camera';

import Button from '../components/button';
import ResponsibleGamblingComponent from '../responsible-gambling-component';
import { withRootTestId } from '@williamhill/rosi-ui-shared/src/lib';
import { useScanBetNavigation, useTicketSearchNavigation } from '../navigation';
import Header from '../components/header';
import { Heading, DisplayHeading } from '@williamhill/rosi-ui-shared/src/components/typography/Typography';

const withTestId = withRootTestId('qa-bet-tracker-home');

export default function HomeComponent() {
  const { goToTicketSearch } = useTicketSearchNavigation();
  const { goToScanBet } = useScanBetNavigation();
  const theme = useTheme();

  return (
    <>
      <HomeSection>
        <Header />
        <main>
          <HomeSectionNav as="nav" size="xl" weight="bold">
            <Button dataTestId={withTestId('scan-bet')} onClick={goToScanBet}>
              <ScanABetText>
                Scan a Bet <Camera color={theme.colors.buttons.primaryContrast} />
              </ScanABetText>
            </Button>
            <Button
              dataTestId={withTestId('search-ticket')}
              onClick={() => goToTicketSearch()}
              text="Search for Ticket Number"
            />
          </HomeSectionNav>
          <InstructionsSection>
            <InstructionsHeading as="header" size="lg" weight="bold">
              How To Scan A Bet
            </InstructionsHeading>
            <main>
              <ol>
                <li>Tap the “Scan a bet” button above</li>
                <li>Hold the camera over the barcode on your bet</li>
                <li>Once your device recognizes the bet you will be able to track your bet live</li>
              </ol>
            </main>
          </InstructionsSection>
          <InstructionsSection>
            <InstructionsHeading as="header" size="lg" weight="bold">
              How To Search For A Ticket Number
            </InstructionsHeading>
            <main>
              <ol>
                <li>Tap the “Search for Ticket Number” button above</li>
                <li>Find the 18 digit ticket number on your paper ticket</li>
                <li>Enter that ticket number into the search box and tap “search”</li>
              </ol>
            </main>
          </InstructionsSection>
        </main>
      </HomeSection>
      <ResponsibleGamblingComponent />
    </>
  );
}

const HomeSectionNav = styled(Heading)`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  padding: 2.6rem 0 4.1rem 0;
  text-align: center;
`;

const InstructionsHeading = styled(DisplayHeading)`
  text-transform: uppercase;
`;

const HomeSection = styled.section`
  & > main {
    padding: 0 3.7rem;
  }
`;

const InstructionsSection = styled.section`
  & > main > ol {
    counter-reset: orderedListItemsCounter;
    margin-block: 1rem;
    padding-inline-start: 0;
  }

  & > main > ol > li {
    position: relative;
    list-style-type: none;
    padding: 1rem 0 1rem 3rem;
  }

  & > main > ol > li:before {
    border-radius: 50%;
    border: 1px solid;
    content: counter(orderedListItemsCounter);
    counter-increment: orderedListItemsCounter;
    height: 2rem;
    line-height: 1.9rem;
    margin-left: -3rem;
    position: absolute;
    text-align: center;
    width: 2rem;
  }
`;

const ScanABetText = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
`;
